import { put } from "redux-saga/effects";
import axios from "../../utils/axios";
import handle from "./handle";
import { GLOBAL_STORE } from "../../store/globalStore/actionType";
import { GET_ALLERGIC_HISTORY_DATA, REQ_ALLERGIC_HISTORY_DATA } from "../../store/allergicStore/actionType";
import { GET_DISEASES_HISTORY_DATA, REQ_DISEASES_HISTORY_DATA } from "../../store/diseasesHistoryStore/actionType";
import { GET_FAMILY_HISTORY_DATA, REQ_FAMILY_HISTORY_DATA } from "../../store/familyhisroryStore/actionType";
import { GET_OTHER_HISTORY, REQ_OTHER_HISTORY } from "../../store/otherHistoryStore/actionType";
import {
  GET_SURGERY_HISTORY_DATA,
  GET_SURGERY_PARTS,
  REQ_SURGERY_HISTORY_DATA,
  REQ_SURGERY_PARTS
} from "../../store/surgeryStore/actionType";

const api = {
  //获取过敏信息
  getAllergicHistoryData: function * ({ params }) {
    yield put ({ type: GLOBAL_STORE, store: { infoLoading: true } });
    const res = yield axios ("/shop/history/other/data", { ...params }, false, "GET");
    yield put ({ type: GLOBAL_STORE, store: { infoLoading: false } });
    if (res && res.code === 1) {
      yield put ({ type: GET_ALLERGIC_HISTORY_DATA, allergicHistory: res.data });
    }
  },
  //获取已选病例
  getDiseasesHistoryData: function * ({ params }) {
    yield put ({ type: GLOBAL_STORE, store: { infoLoading: true } });
    const res = yield axios ("/shop/history/other/index", { ...params }, false, "GET");
    yield put ({ type: GLOBAL_STORE, store: { infoLoading: false } });
    if (res && res.code === 1) {
      yield put ({ type: GET_DISEASES_HISTORY_DATA, diseaseHistory: res.data });
    }
  },
  //获取家族病历
  getFamilyHistoryData: function * ({ params }) {
    yield put ({ type: GLOBAL_STORE, store: { infoLoading: true } });
    const res = yield axios ("/shop/history/other/data", { ...params }, false, "GET");
    yield put ({ type: GLOBAL_STORE, store: { infoLoading: false } });
    if (res && res.code === 1) {
      yield put ({ type: GET_FAMILY_HISTORY_DATA, familyHistory: res.data });
    }
  },
  //获取烟酒史信息
  getOtherHistory: function * ({ params }) {
    yield put ({ type: GLOBAL_STORE, store: { infoLoading: true } });
    const res = yield axios ("/shop/history/smoke/index", { ...params }, false, "GET");
    yield put ({ type: GLOBAL_STORE, store: { infoLoading: false } });
    if (res && res.code === 1) {
      yield put ({ type: GET_OTHER_HISTORY, values: handle.handleOtherHistory (res.data) });
    }
  },
  //获取手术部位列表
  getSurgeryParts: function * ({ params }) {
    const res = yield axios ("/shop/history/list", { ...params }, false, "GET");
    if (res && res.code === 1) {
      yield put ({ type: GET_SURGERY_PARTS, surgeryParts: res.data });
    }
  },
  //获取手术列表
  getSurgeryList: function * ({ surgeryList }) {
    yield put ({ type: GLOBAL_STORE, store: { globalLoading: true } });
    const res = yield axios (`/shop/history/surgery/index`, { ...surgeryList }, false, "GET");
    yield put ({ type: GLOBAL_STORE, store: { globalLoading: false } });
    if (res && res.code === 1) {
      yield put ({ type: GET_SURGERY_HISTORY_DATA, values: handle.handleSurgeryList (res.data) });
    }
  },
  //选择
  setHistoryData: (params) => {
    return axios (`/shop/history/other/edit?sid=${params.sid}&id=${params.id}`, { ...params }, false, "POST");
  },
  //获取备选列表
  getHistoryList: (params) => {
    return axios (`/shop/history/list`, { ...params }, false, "GET");
  },
  //编辑烟酒史
  editSmokeOrDrinkHabit: (params) => {
    return axios (`/shop/history/smoke/edit?sid=${params.sid}`, { ...params }, false, "POST");
  },
  //更新手术史
  updateSurgeryList: (params) => {
    return axios (`/shop/history/surgery/index`, { ...params }, false, "GET");
  },
  //更新手术部位
  updateSurgeryParts: (params) => {
    return axios (`/shop/history/surgery/edit?sid=${params.sid}`, { ...params }, false, "POST");
  },
  //删除手术史
  deleteSurgeryItem: (params) => {
    return axios ("/shop/history/surgery/del", { ...params }, false, "GET");
  },
};
export {
  REQ_ALLERGIC_HISTORY_DATA,
  REQ_DISEASES_HISTORY_DATA,
  REQ_FAMILY_HISTORY_DATA,
  REQ_OTHER_HISTORY,
  REQ_SURGERY_HISTORY_DATA,
  REQ_SURGERY_PARTS
};
export default api;
